import { Button, Card, CardContent, CardHeader, Stack, Typography } from "@bvhi/ui-base";
import { AccountBoxIcon } from "@bvhi/ui-icons";
import { useTranslation } from "react-i18next";
import { useAuthentication } from "../../../../hooks/use-authentication";

export const LoginCard = () => {
  const { login } = useAuthentication();
  const { t } = useTranslation(["home"]);

  return (
    <Card>
      <CardHeader subheader={t("home:home.login.card.sub.title")} title={t("home:home.login.card.title")} />
      <CardContent>
        <Stack spacing={1}>
          <Typography sx={{ fontWeight: 600, minHeight: 40 }}>{t("home:home.login.card.body")}</Typography>{" "}
          <Button onClick={() => login()} startIcon={<AccountBoxIcon />} sx={{ maxWidth: 175 }} type="button">
            {t("home:home.login.card.action")}{" "}
          </Button>{" "}
        </Stack>{" "}
      </CardContent>
    </Card>
  );
};
